// Action Types
export const FETCH_SPOT_CONTACTS_REQUEST = "FETCH_SPOT_CONTACTS_REQUEST";
export const FETCH_SPOT_CONTACTS_SUCCESS = "FETCH_SPOT_CONTACTS_SUCCESS";
export const FETCH_SPOT_CONTACTS_FAILURE = "FETCH_SPOT_CONTACTS_FAILURE";

// Action Creators
export const FetchSpotContactsRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_REQUEST,
      payload: { clientName, accountName, userId, type },
    });
  };
};
export const FetchSpotContactsSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_SUCCESS,
  payload: data,
});
export const FetchSpotContactsFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_FAILURE,
  payload: error,
});

export const updateContactBookmarkSuccess = (contactId, data) => ({
  type: 'UPDATE_CONTACT_BOOKMARK_SUCCESS',
  payload: { contactId, data },
});


export const updateContactReadSuccess = (contactId, data) => ({
  type: 'UPDATE_CONTACT_READ_SUCCESS',
  payload: { contactId, data },
});

export const updateContactEmailUpdate = (contactId, data) => ({
  type: 'UPDATE_CONTACT_EMAIL_UPDATE',
  payload: { contactId, data },
});
export const updateContactPhoneUpdate = (contactId, data) => {
  
  debugger
  return{
  type: 'UPDATE_CONTACT_PHONE_UPDATE',
  payload: { contactId, data },
}};
